import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Logo extends Vue {
  public get isAtHome() {
    return this.$route.matched.some((record) => record.meta.atHome);
  }

  protected get headerLogoSrc(): string {
    if (this.$route.params.screening === undefined) {
      // Load a default logo instead
      return '';
    }
    const suName = this.$route.params.screening.toLowerCase();

    // TODO: move these in a configuration file instead ?
    const svg = ['fr'];
    const jpg = ['vd', 'vs', 'ti', 'tg'];
    const png = ['bb', 'gr', 'ge'];

    if (this.isAtHome) {
      if (jpg.includes(suName)) {
        return require(`@/assets/logos/${suName}.jpg`);
      } else if (svg.includes(suName)) {
        return require(`@/assets/logos/${suName}.svg`);
      } else if (png.includes(suName)) {
        return require(`@/assets/logos/${suName}.png`);
      }
    }

    // Load a default logo (same for all SU)
    // eslint-disable-next-line quotes
    return require(`@/assets/logos/default.png`);
  }
}
